import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';
import { apiPost, apiGet } from '../utils/api';
import API_BASE_URL from '../config/api-config';

const PlatformSettingsCard = ({ platform, feedId, feedName }) => {
  const navigate = useNavigate();
  
  // Platform configurations with inline SVGs
  const platformConfig = {
    facebook: { 
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" style={{ width: '32px', height: '32px' }}>
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      color: '#1877f2', 
      label: 'Facebook' 
    },
    instagram: { 
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" style={{ width: '32px', height: '32px' }}>
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      ),
      color: '#e4405f', 
      label: 'Instagram' 
    },
    linkedin: { 
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" style={{ width: '32px', height: '32px' }}>
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ),
      color: '#0a66c2', 
      label: 'LinkedIn' 
    },
    x: { 
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" style={{ width: '32px', height: '32px' }}>
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      ),
      color: '#000000', 
      label: 'X (Twitter)' 
    }
  };

  const config = platformConfig[platform];

  // OAuth credentials
  const FACEBOOK_APP_ID = "1245931220393560";
  const X_CLIENT_ID = "SzlrUUlfdnNPMEVRbG9jdHpDQ3E6MTpjaQ";
  const LINKEDIN_CLIENT_ID = "78jt4f1t3iq744";

  // Connection state
  const [isConnected, setIsConnected] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [connectedAccountName, setConnectedAccountName] = useState('');
  
  // Privacy consent state
  const [showPrivacyConsent, setShowPrivacyConsent] = useState(false);
  const [pendingProvider, setPendingProvider] = useState(null);
  const [pendingOAuthData, setPendingOAuthData] = useState(null);

  // Image and prompt settings state
  const [includeThumbnails, setIncludeThumbnails] = useState(false);
  const [includeEpisodeLink, setIncludeEpisodeLink] = useState(false);

  // Per-variant prompt state
  const [variantPrompts, setVariantPrompts] = useState({
    v1: { prompt: '', useCustomPrompt: false, label: platform === 'instagram' ? 'Prompt' : 'Prompt 1' },
    v2: { prompt: '', useCustomPrompt: false, label: 'Prompt 2' },
    v3: { prompt: '', useCustomPrompt: false, label: 'Prompt 3' }
  });
  const [savingVariant, setSavingVariant] = useState(null);

  useEffect(() => {
    fetchConnectionStatus();
    loadPlatformPreferences();
    loadCustomPrompt();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feedId, platform]);

  // Fetch connection status for this specific platform
  const fetchConnectionStatus = async () => {
    if (!feedId) return;
    
    try {
      setIsLoading(true);
      const session = await fetchAuthSession();
      const userId = session.tokens?.idToken?.payload?.sub;

      console.log(`✅ Fetching connection status for ${platform} on feed ${feedId}`);

      const data = await apiPost('/connections/status', { userId, feedId });
      
      // Updated to handle new response format
      const platformData = data[platform];
      setIsConnected(platformData?.connected || false);
      setConnectedAccountName(platformData?.accountName || '');
      
    } catch (error) {
      console.error(`❌ Error fetching ${platform} connection status:`, error);
      setConnectionStatus(`❌ Failed to load connection status`);
      setIsConnected(false);
      setConnectedAccountName('');
    } finally {
      setIsLoading(false);
    }
  };

  // Load platform preferences (image settings)
  const loadPlatformPreferences = async () => {
    try {
      const response = await apiGet('/getPlatformPreferences', { feedId });
      const platformPrefs = response.preferences?.[platform] || {};
      setIncludeThumbnails(platformPrefs.includeThumbnails || false);
      setIncludeEpisodeLink(platformPrefs.includeEpisodeLink || false);
    } catch (err) {
      console.error('Error loading preferences:', err);
    }
  };

  // Load custom prompts for all variants
  const loadCustomPrompt = async () => {
    try {
      const response = await apiGet('/getCustomPrompts', { feedId });
      const platformPrompts = response.customPrompts?.[platform] || {};

      // Determine how many variants this platform has
      const maxVariants = platform === 'instagram' ? 1 : 3;

      const newVariantPrompts = {};
      for (let v = 1; v <= maxVariants; v++) {
        const variantKey = `v${v}`;
        const variantData = platformPrompts[variantKey] || {};
        newVariantPrompts[variantKey] = {
          prompt: variantData.prompt || '',
          useCustomPrompt: variantData.useCustomPrompt || false,
          label: variantData.label || getVariantLabel(v)
        };
      }

      setVariantPrompts(prev => ({ ...prev, ...newVariantPrompts }));
    } catch (err) {
      console.error('Error loading custom prompts:', err);
    }
  };

  // Helper to get default variant label
  const getVariantLabel = (variantNumber) => {
    if (platform === 'instagram') return 'Prompt';
    switch (variantNumber) {
      case 1: return 'Prompt 1';
      case 2: return 'Prompt 2';
      case 3: return 'Prompt 3';
      default: return `Prompt ${variantNumber}`;
    }
  };

  // Privacy consent handler
  const handlePrivacyConsent = async (accepted) => {
    setShowPrivacyConsent(false);
    
    if (!accepted) {
      setConnectionStatus("❌ Privacy policy consent required to connect social accounts");
      setPendingProvider(null);
      setPendingOAuthData(null);
      return;
    }

    if (pendingOAuthData) {
      console.log("✅ Privacy consent granted, proceeding with OAuth:", pendingProvider);
      setConnectionStatus(`🔄 Redirecting to ${pendingProvider}...`);
      window.location.href = pendingOAuthData.oauthUrl;
    }
    
    setPendingProvider(null);
    setPendingOAuthData(null);
  };

  const setOAuthReturnPath = () => {
    const returnPath = `/podcast/${feedId}/settings`;
    sessionStorage.setItem("oauth_return_path", returnPath);
    sessionStorage.setItem("oauth_return_context", "feed_settings");
  };

  // Facebook connection handler
  const handleFacebookLogin = async () => {
    try {
      setConnectionStatus('');
      
      const session = await fetchAuthSession();
      const userId = session.tokens?.idToken?.payload?.sub;
      
      if (!userId) {
        console.error("❌ No userId found");
        setConnectionStatus("Authentication error: User ID not found");
        return;
      }
      
      console.log(`🔍 Checking for existing Meta user token for user ${userId}...`);

      const tokenStatus = await apiPost('/connections/status', { userId });
      // Updated to use the new hasMetaUserToken field directly
      const hasMetaUserToken = tokenStatus.hasMetaUserToken;
      
      console.log(`🔍 Meta user token status: ${hasMetaUserToken ? 'EXISTS' : 'MISSING'}`);
      
      if (!hasMetaUserToken) {
        console.log("🔄 No Meta user token found - initiating full OAuth flow...");
        setConnectionStatus("🔄 Connecting to Meta (Facebook/Instagram)...");
        
        sessionStorage.setItem("oauth_provider", "facebook");
        sessionStorage.setItem("oauth_feedId", feedId);
        sessionStorage.setItem("oauth_feedName", feedName);
        sessionStorage.setItem("oauth_action", "full_auth_then_page_selection");
        
        const redirectUri = encodeURIComponent(`${API_BASE_URL}/facebook/auth`);
        const essentialScopes = ['email', 'public_profile', 'pages_show_list', 'pages_manage_posts'];
        const optionalScopes = ['instagram_basic', 'instagram_content_publish', 'business_management'];
        const allScopes = [...essentialScopes, ...optionalScopes].join(',');
        
        const stateParam = encodeURIComponent(JSON.stringify({ 
          userId, feedId, action: 'full_auth_then_page_selection' 
        }));
        
        const facebookOAuthUrl = `https://www.facebook.com/v19.0/dialog/oauth?client_id=${FACEBOOK_APP_ID}&redirect_uri=${redirectUri}&state=${stateParam}&scope=${allScopes}&response_type=code&auth_type=rerequest`;
        
        console.log("🔄 Redirecting to Facebook OAuth for full authentication...");
        window.location.href = facebookOAuthUrl;
        
      } else {
        console.log("✅ Meta user token exists - proceeding to page selection...");
        setConnectionStatus("🔄 Opening Facebook page selector...");
        
        sessionStorage.setItem("oauth_provider", "facebook");
        sessionStorage.setItem("oauth_feedId", feedId);
        sessionStorage.setItem("oauth_feedName", feedName);
        sessionStorage.setItem("oauth_action", "feed_connection");
        setOAuthReturnPath();
        
        const params = new URLSearchParams();
        params.append('userId', userId);
        params.append('feedId', feedId);
        params.append('feedName', feedName);
        params.append('isFeedLevel', 'true');
        
        navigate(`/facebook-page-selector?${params.toString()}`);
      }
      
    } catch (error) {
      console.error("❌ Error in Facebook login flow:", error);
      setConnectionStatus("❌ Failed to initiate Facebook connection");
    }
  };

  // Instagram connection handler  
  const handleInstagramLogin = async () => {
    try {
      setConnectionStatus('');
      
      const session = await fetchAuthSession();
      const userId = session.tokens?.idToken?.payload?.sub;

      if (!userId) {
        console.error("❌ No userId found");
        setConnectionStatus("Authentication error: User ID not found");
        return;
      }
      
      console.log("🔄 Navigating to Instagram account selector...");
      setConnectionStatus("🔄 Opening Instagram account selector...");
      
      const params = new URLSearchParams();
      params.append('userId', userId);
      params.append('feedId', feedId);
      params.append('feedName', feedName);
      
      navigate(`/facebook-page-selector?${params.toString()}`);
      
    } catch (error) {
      console.error("❌ Error navigating to Instagram account selector:", error);
      setConnectionStatus("❌ Failed to open account selector");
    }
  };

  // X (Twitter) connection handler
  const handleXLogin = async () => {
    const generateCodeVerifier = () => {
      const array = new Uint8Array(32);
      window.crypto.getRandomValues(array);
      return btoa(String.fromCharCode.apply(null, array))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    };

    const generateCodeChallenge = async (codeVerifier) => {
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);
      const digest = await window.crypto.subtle.digest('SHA-256', data);
      return btoa(String.fromCharCode.apply(null, new Uint8Array(digest)))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    };

    try {
      const codeVerifier = generateCodeVerifier();
      const codeChallenge = await generateCodeChallenge(codeVerifier);

      sessionStorage.setItem("x_code_verifier", codeVerifier);
      sessionStorage.setItem("oauth_provider", "x");
      sessionStorage.setItem("oauth_feedId", feedId);
      setOAuthReturnPath();

      const redirectUri = encodeURIComponent(`${window.location.origin}/account-settings`);
      const xOAuthUrl = `https://twitter.com/i/oauth2/authorize?response_type=code&client_id=${X_CLIENT_ID}&redirect_uri=${redirectUri}&scope=tweet.read%20tweet.write%20users.read%20offline.access%20media.write&state=randomstring&code_challenge=${codeChallenge}&code_challenge_method=S256`;

      console.log("🔄 Redirecting to X OAuth for feed:", feedId);
      window.location.href = xOAuthUrl;
    } catch (error) {
      console.error("❌ Error initiating X login:", error);
      setConnectionStatus("❌ Failed to initiate X connection");
    }
  };

  // LinkedIn connection handler
  const handleLinkedInLogin = async () => {
    try {
      sessionStorage.setItem("oauth_provider", "linkedin");
      sessionStorage.setItem("oauth_feedId", feedId);
      setOAuthReturnPath();
    
      const redirectUri = encodeURIComponent(`${window.location.origin}/account-settings`);
      const linkedInOAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${LINKEDIN_CLIENT_ID}&redirect_uri=${redirectUri}&scope=openid%20profile%20w_member_social&state=${encodeURIComponent(feedId)}`;
      
      console.log("🔄 Redirecting to LinkedIn OAuth for feed:", feedId);
      window.location.href = linkedInOAuthUrl;
    } catch (error) {
      console.error("❌ Error initiating LinkedIn login:", error);
      setConnectionStatus("❌ Failed to initiate LinkedIn connection");
    }
  };

  // Main connect handler
  const handleConnect = () => {
    switch (platform) {
      case 'facebook':
        handleFacebookLogin();
        break;
      case 'instagram':
        handleInstagramLogin();
        break;
      case 'linkedin':
        handleLinkedInLogin();
        break;
      case 'x':
        handleXLogin();
        break;
      default:
        console.error('Unknown platform:', platform);
    }
  };

  // Disconnect handler
  const handleDisconnectSocial = async () => {
    if (!window.confirm(`Are you sure you want to disconnect ${config.label} from "${feedName}"?`)) {
      return;
    }

    try {
      console.log(`📡 Disconnecting ${platform} from feed ${feedId}...`);

      const result = await apiPost('/disconnect-social-media', {
        provider: platform,
        feedId: feedId
      });

      setConnectionStatus(`✅ ${platform} disconnected successfully from feed!`);
      console.log(`✅ ${platform} disconnected successfully from feed ${feedId}:`, result);
      setIsConnected(false);
      setConnectedAccountName('');
    } catch (error) {
      console.error(`❌ Error disconnecting ${platform} from feed ${feedId}:`, error);
      setConnectionStatus(`❌ Failed to disconnect ${platform} from feed`);
    }
  };

  // Toggle Images Handler
  const handleToggleImages = async () => {
    // Instagram always requires images, so don't allow toggling
    if (platform === 'instagram') {
      return;
    }
    
    try {
      const newValue = !includeThumbnails;
      await apiPost('/updatePlatformPreferences', {
        feedId,
        platform,
        preferences: { includeThumbnails: newValue }
      });
      setIncludeThumbnails(newValue);
    } catch (error) {
      console.error('Error toggling images:', error);
      setConnectionStatus('Failed to update image settings');
    }
  };

  //Toggle Link Handler
  const handleToggleEpisodeLink = async () => {
    try {
      const newValue = !includeEpisodeLink;
      await apiPost('/updatePlatformPreferences', {
        feedId,
        platform,
        preferences: { 
          includeThumbnails: includeThumbnails,
          includeEpisodeLink: newValue 
        }
      });
      setIncludeEpisodeLink(newValue);
    } catch (error) {
      console.error('Error toggling episode link:', error);
      setConnectionStatus('Failed to update episode link settings');
    }
  };

  // Toggle Custom Prompt Handler for specific variant
  const handleToggleVariantPrompt = async (variantNumber) => {
    const variantKey = `v${variantNumber}`;
    const currentState = variantPrompts[variantKey];
    const newValue = !currentState.useCustomPrompt;

    try {
      await apiPost('/updateCustomPrompt', {
        feedId,
        platform,
        variant: variantNumber,
        useCustomPrompt: newValue
      });

      setVariantPrompts(prev => ({
        ...prev,
        [variantKey]: { ...prev[variantKey], useCustomPrompt: newValue }
      }));
    } catch (error) {
      console.error(`Error toggling custom prompt for variant ${variantNumber}:`, error);
      setConnectionStatus(`Failed to toggle custom prompt for ${currentState.label}`);
    }
  };

  // Save Prompt Handler for specific variant
  const handleSaveVariantPrompt = async (variantNumber) => {
    const variantKey = `v${variantNumber}`;
    const currentState = variantPrompts[variantKey];

    try {
      setSavingVariant(variantNumber);
      await apiPost('/updateCustomPrompt', {
        feedId,
        platform,
        variant: variantNumber,
        customPrompt: currentState.prompt,
        useCustomPrompt: true
      });

      setVariantPrompts(prev => ({
        ...prev,
        [variantKey]: { ...prev[variantKey], useCustomPrompt: true }
      }));

      setConnectionStatus(`✅ ${currentState.label} prompt saved`);
      setTimeout(() => setConnectionStatus(''), 3000);
    } catch (error) {
      console.error(`Error saving prompt for variant ${variantNumber}:`, error);
      setConnectionStatus(`❌ Failed to save ${currentState.label} prompt`);
    } finally {
      setSavingVariant(null);
    }
  };

  // Update variant prompt text
  const handleVariantPromptChange = (variantNumber, newPrompt) => {
    const variantKey = `v${variantNumber}`;
    setVariantPrompts(prev => ({
      ...prev,
      [variantKey]: { ...prev[variantKey], prompt: newPrompt }
    }));
  };

  // Restore Default Prompt Handler for specific variant
  const handleRestoreVariantDefault = async (variantNumber) => {
    const variantKey = `v${variantNumber}`;
    const currentState = variantPrompts[variantKey];

    if (!window.confirm(`Restore default ${currentState.label} prompt?`)) {
      return;
    }

    try {
      setSavingVariant(variantNumber);
      await apiPost('/updateCustomPrompt', {
        feedId,
        platform,
        variant: variantNumber,
        customPrompt: '',
        useCustomPrompt: false
      });

      setVariantPrompts(prev => ({
        ...prev,
        [variantKey]: { ...prev[variantKey], prompt: '', useCustomPrompt: false }
      }));

      setConnectionStatus(`✅ ${currentState.label} prompt restored to default`);
      setTimeout(() => setConnectionStatus(''), 3000);
    } catch (error) {
      console.error(`Error restoring default for variant ${variantNumber}:`, error);
      setConnectionStatus(`❌ Failed to restore ${currentState.label} default`);
    } finally {
      setSavingVariant(null);
    }
  };

  // Privacy Consent Modal
  const PrivacyConsentModal = ({ isOpen, onAccept, onDecline, provider }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
          <h3 className="text-xl font-semibold mb-4">Privacy Policy Consent</h3>
          <p className="text-gray-600 mb-4">
            To connect {provider} to "{feedName}", you must agree to our Privacy Policy and Terms of Service.
            This will allow us to post content to your {provider} account on your behalf.
          </p>
          <div className="flex space-x-4">
            <button
              onClick={onAccept}
              className="flex-1 bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
            >
              Accept & Continue
            </button>
            <button
              onClick={onDecline}
              className="flex-1 bg-gray-300 text-gray-700 py-2 px-4 rounded hover:bg-gray-400"
            >
              Decline
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (isLoading) {
    return (
      <div className="compact-card">
        <div className="compact-header">
          <div className="compact-icon" style={{ backgroundColor: config.color }}>
            {config.icon}
          </div>
          <div className="compact-title">
            <h3>{config.label}</h3>
            <p className="compact-status">Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PrivacyConsentModal
        isOpen={showPrivacyConsent}
        onAccept={() => handlePrivacyConsent(true)}
        onDecline={() => handlePrivacyConsent(false)}
        provider={pendingProvider}
      />

      <div className={`compact-card ${!isConnected ? 'disconnected' : ''}`}>
        <div className="compact-header">
          <div className="compact-icon" style={{ backgroundColor: config.color }}>
            {config.icon}
          </div>
          <div className="compact-title">
            <h3>{config.label}</h3>
            <p className={`compact-status ${isConnected ? 'connected' : ''}`}>
              {isConnected ? `✓ Connected` : 'Not connected'}
            </p>
            {connectedAccountName && (
              <div style={{ fontSize: '0.875rem', color: '#666', marginTop: '4px' }}>
                {connectedAccountName}
              </div>
            )}
          </div>
        </div>

        {connectionStatus && (
          <div className={`connection-status-message p-3 mb-4 rounded-lg text-sm ${
            connectionStatus.includes('❌') ? 'bg-red-100 text-red-800' : 
            connectionStatus.includes('✅') ? 'bg-green-100 text-green-800' :
            connectionStatus.includes('⚠️') ? 'bg-yellow-100 text-yellow-800' :
            'bg-blue-100 text-blue-800'
          }`}>
            {connectionStatus}
          </div>
        )}

        {isConnected ? (
          <>
            <div className="compact-settings">
              <div className="quick-toggle">
                <span>Include Images {platform === 'instagram' && <span style={{ fontSize: '12px', color: 'var(--text-tertiary)' }}>(required)</span>}</span>
                <div 
                  className={`toggle ${(platform === 'instagram' || includeThumbnails) ? 'on' : ''} ${platform === 'instagram' ? 'disabled' : ''}`}
                  onClick={handleToggleImages}
                  style={{ 
                    cursor: platform === 'instagram' ? 'not-allowed' : 'pointer',
                    opacity: platform === 'instagram' ? 0.6 : 1
                  }}
                ></div>
              </div>

              <div className="quick-toggle">
                <span>Include Episode Link</span>
                <div
                  className={`toggle ${includeEpisodeLink ? 'on' : ''}`}
                  onClick={handleToggleEpisodeLink}
                  style={{ cursor: 'pointer' }}
                ></div>
              </div>

              {/* Helper text for image/link settings - only show for non-Instagram platforms */}
              {platform !== 'instagram' && (includeThumbnails || includeEpisodeLink) && (
                <p style={{
                  fontSize: '12px',
                  color: 'var(--text-tertiary, #888)',
                  marginTop: '8px',
                  marginBottom: '4px'
                }}>
                  {includeThumbnails && includeEpisodeLink
                    ? 'Images and links only apply to the first post variant'
                    : includeThumbnails
                      ? 'Images only apply to the first post variant'
                      : 'Links only apply to the first post variant'
                  }
                </p>
              )}

              {/* Per-variant custom prompt sections */}
              <div className="variant-prompts-section">
                <div className="variant-prompts-header">
                  <span className="variant-prompts-title">Custom Prompts</span>
                </div>
                {Object.entries(variantPrompts)
                  .filter(([key]) => {
                    // Only show relevant variants (1 for Instagram, 3 for others)
                    const variantNum = parseInt(key.replace('v', ''), 10);
                    return platform === 'instagram' ? variantNum === 1 : variantNum <= 3;
                  })
                  .map(([variantKey, variant]) => {
                    const variantNumber = parseInt(variantKey.replace('v', ''), 10);
                    return (
                      <div key={variantKey} className="variant-prompt-item">
                        <div className="quick-toggle">
                          <span className="variant-label">{variant.label}</span>
                          <div
                            className={`toggle ${variant.useCustomPrompt ? 'on' : ''}`}
                            onClick={() => handleToggleVariantPrompt(variantNumber)}
                            style={{ cursor: 'pointer' }}
                          ></div>
                        </div>

                        {variant.useCustomPrompt && (
                          <div className="prompt-editor">
                            <textarea
                              className="prompt-textarea"
                              value={variant.prompt}
                              onChange={(e) => handleVariantPromptChange(variantNumber, e.target.value)}
                              placeholder={`Example: "Write in a witty, conversational tone aimed at entrepreneurs.

POST STYLE: Share a surprising insight
TONE: Bold but professional
EMOJI: Use 2-3 emojis for emphasis
CTA: End with a thought-provoking question"

Note: Character limits and hashtag rules are automatically enforced.`}
                              rows={6}
                            />
                            <div className="prompt-actions">
                              <button
                                className="btn-save-prompt"
                                onClick={() => handleSaveVariantPrompt(variantNumber)}
                                disabled={savingVariant === variantNumber}
                              >
                                {savingVariant === variantNumber ? 'Saving...' : 'Save'}
                              </button>
                              <button
                                className="btn-restore-prompt"
                                onClick={() => handleRestoreVariantDefault(variantNumber)}
                                disabled={savingVariant === variantNumber}
                              >
                                Restore Default
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })
                }
              </div>
            </div>
            
            <button className="disconnect-btn" onClick={handleDisconnectSocial}>
              Disconnect
            </button>
          </>
        ) : (
          <button className="connect-btn" onClick={handleConnect}>
            Connect
          </button>
        )}
      </div>
    </>
  );
};

export default PlatformSettingsCard;